"use client";
import type { ReactElement } from "react";
import { CsegmentedpanelLayout } from "./CsegmentedpanelLayout";
import { CSEGMENTED_PANEL_PRESENTATION } from "./csegmentedpanel.styles";
import {
  CsegmentedpanelVariant,
  type CsegmentedpanelVariantProps,
} from "./csegmentedpanel.types";

export function CsegmentedpanelLabelBands(
  props: CsegmentedpanelVariantProps,
): ReactElement {
  return (
    <CsegmentedpanelLayout
      {...props}
      presentation={
        CSEGMENTED_PANEL_PRESENTATION[CsegmentedpanelVariant.LabelBands]
      }
    />
  );
}
